module.exports = __webpack_public_path__ + "a17d279f/img/ion_calendar-number.3ac5bd07.svg";